import { render, staticRenderFns } from "./PartsSettings.vue?vue&type=template&id=063e110c&scoped=true"
import script from "./PartsSettings.vue?vue&type=script&lang=js"
export * from "./PartsSettings.vue?vue&type=script&lang=js"
import style0 from "./PartsSettings.vue?vue&type=style&index=0&id=063e110c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "063e110c",
  null
  
)

export default component.exports